import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { EcplTabNavigationComponent } from './ecpl-tab-navigation.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@NgModule({
  declarations: [EcplTabNavigationComponent],
  imports: [BrowserModule, CommonModule, RouterModule, FormsModule, TranslatePipe, TranslateDirective],
  exports: [EcplTabNavigationComponent, CommonModule]
})
export class EcplTabNavigationModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: EcplTabNavigationModule
    };
  }
}
